import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from '@/App'
import { SessionProvider } from '@/features/auth/SessionContext'
import { I18nProvider } from '@/i18n'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root fehlt in index.html')

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <SessionProvider>
        <App />
      </SessionProvider>
    </I18nProvider>
  </StrictMode>,
)
